import React from "react";

export default function FinanceSettingsForm(props) {
    return <>
        <div className="modal modal-blur fade" id="modal-report" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Finance Settings Form</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Payment Name</label>
                                <input
                                    name="PAYMENT_TYPE"
                                    className="form-control"
                                    id="PAYMENT_TYPE"
                                    value={props.formData.PAYMENT_TYPE}
                                    onChange={props.onEdit}
                                    placeholder="Payment Name"
                                />
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Code</label>
                                <input
                                    type="text"
                                    name="PAYMENT_CODE"
                                    className="form-control"
                                    id="PAYMENT_CODE"
                                    value={props.formData.PAYMENT_CODE}
                                    onChange={props.onEdit}
                                    placeholder="Payment Code"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Payment Type ID</label>
                                <input
                                    type="text"
                                    name="PAYMENT_TYPE_ID"
                                    className="form-control"
                                    id="PAYMENT_TYPE_ID"
                                    value={props.formData.PAYMENT_TYPE_ID}
                                    onChange={props.onEdit}
                                    placeholder="Payment Type ID"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Payment Amount</label>
                                <input
                                    type="number"
                                    name="PAYMENT_FEE"
                                    className="form-control"
                                    id="PAYMENT_FEE"
                                    value={props.formData.PAYMENT_FEE}
                                    onChange={props.onEdit}
                                    placeholder="Payment Amount"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Status</label>
                                <select className="form-control" name="PAYMENT_STATUS" id="PAYMENT_STATUS" value={props.formData.PAYMENT_STATUS} onChange={props.onEdit}>
                                    <option value="">Select Status</option>
                                    <option value="1">Active</option>
                                    <option value="0">In-Active</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a href="#" id="closeModal" className="btn btn-link link-secondary" data-bs-dismiss="modal">
                            Cancel
                        </a>
                        {
                            props.IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={props.onSubmit} className="btn btn-primary ms-auto">
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24"
                                                 height="24"
                                                 viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                                                 strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                        </svg>
                                             Submit
                                        </span>
                                </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}